import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { AccessTime }                           from "@material-ui/icons";
import { default as React, FC }                 from "react";
import { useDispatch, useSelector }             from "react-redux";
import Account                                  from "../../../domain/account/Account";
import MenuType                                 from "../../../domain/menu/MenuType";
import { ResKaState }                           from "../../../index";
import RouterDispatcher                         from "../../../infrastructure/redux/router/RouterDispatcher";

interface Props {
  menuType: MenuType
}

const MenuReservationButton: FC<Props> = (props: Props) => {
  const {menuType} = props;
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());
  const account: Account = useSelector((state: ResKaState) => state.account);

  if (!account.options.hasReservation()) {
    return null;
  }

  return (
    <>
      {
        menuType === MenuType.RESERVATION
          ?
          <section className="reska-menu-selected">
            <ListItem button={ true } divider={ true } onClick={ () => routerDispatcher.reservation() }>
              <ListItemIcon>
                <AccessTime/>
              </ListItemIcon>
              <ListItemText primary="予約管理" className="reska-menu-selected-text"/>
            </ListItem>
          </section>
          :
          <ListItem button={ true } divider={ true } onClick={ () => routerDispatcher.reservation() }>
            <ListItemIcon>
              <AccessTime/>
            </ListItemIcon>
            <ListItemText primary="予約管理"/>
          </ListItem>
      }
    </>
  );
};

export default MenuReservationButton;
